<template>
  <div id="default">
    <div class="container position-relative">
      <div class="intro-header"><router-link :to="{ name: 'Default'}"><img class="header-intro__logo" src="./../assets/img/logos/driessengroep-logo.svg" alt="Driessen Groep"></router-link></div>
      <div class="intro-content">
        <div class="intro-content__top">
          <div class="intro-title-top intro-title--write" data-aos="fade-down">Test je</div>
          <div class="intro-title-main intro-title--sans" data-aos="fade-down" data-aos-once="true" data-aos-delay="100">WERKGELUK</div>
        </div>
        <div class="row">
          <div class="header-intro__paragraph pl-md-15 col-md-7" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
            <div class="d-flex mb-3">
              <strong>Vul hier uw toegangscode in</strong>
            </div>
            <div class="d-block d-sm-flex">
              <input autocapitalize="characters" v-on:keypress="checkValue" v-on:keyup="checkValue" v-on:keyup.enter="submitForm" :class="isError" placeholder="Toegangscode" class="login__code mr-0 mr-3 mb-3" type="text" v-model="code" name="code" v-uppercase/>
              <input type="submit" v-on:click="checkForm" v-model="login" class="login__code-button btn btn-color-02 to-quiz">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  
  import projects from '../../data/projects.json'

  export default {
    name: 'Default',
    data() {
      return {
        events: [],
        code: null,
        codes: [],
        codeSuccess: false,
        login: 'Inloggen',
        projects: projects[0]
      }
    },
    computed: {
      isError() {
        return this.codeSuccess ? 'login__code--success' : '';
      }
    },
    methods: {
      checkForm() {
        if (this.codes.indexOf(this.code) !== -1){
          this.$router.push(this.code);
        }
        this.checkValue();
      },
      checkValue() {
        console.log(this.code);
        if (this.codes.indexOf(this.code) !== -1){
          this.codeSuccess = true;
        } else {
          this.codeSuccess = false;
        }
      },
      submitForm() {
        if (this.codes.indexOf(this.code) !== -1){
          this.$router.push(this.code);
        }
      },
      getCodes() {
        var array = [];
        Object.keys(this.projects).forEach(function (key) {
          array.push(key);
        });
        this.codes = array;
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.getCodes();
      this.toggleBodyClass('addClass', 'default');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'default');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Default.vue